import { c as _c } from "react/compiler-runtime";
import BlurTooltip from '@components/blur-tooltip/BlurTooltip';
import { useViewport } from '@lib/tools/hooks/useViewport';
import cn from 'classnames';
import style from './GenplanSignatures.module.scss';
const signaturesArr = [{
  id: 1,
  text: 'ФМБА России',
  style: style.fmba
}, {
  id: 2,
  text: 'Детская поликлиника',
  style: style.hospital
}, {
  id: 3,
  text: 'ФГБУ Центр оториноларингологии',
  style: style.fgbu
}, {
  id: 4,
  text: '3-я очередь',
  style: style.stageThree
}, {
  id: 5,
  text: '1-ая очередь корпус 1',
  style: style.stageOneOne
}, {
  id: 6,
  text: 'Школа и детский сад',
  style: style.school
}, {
  id: 7,
  text: 'ФГУП ГосНИИ',
  style: style.fgup
}, {
  id: 8,
  text: '2-ая очередь корпус 2.1',
  style: style.stageTwoOne
}, {
  id: 9,
  text: '2-ая очередь корпус 2.3',
  style: style.stageTwoThree
}, {
  id: 10,
  text: '2-ая очередь корпус 2.2',
  style: style.stageTwoTwo
}];
const signaturesArrMob = [{
  id: 1,
  text: 'Корпус 1',
  style: style.stageOneOne
}, {
  id: 2,
  text: '3-я очередь',
  style: style.stageThree
}, {
  id: 3,
  text: 'Школа и детский сад',
  style: style.school
}, {
  id: 4,
  text: 'Корпус 2.1',
  style: style.stageTwoOne
}, {
  id: 5,
  text: 'Корпус 2.3',
  style: style.stageTwoThree
}, {
  id: 6,
  text: 'Корпус 2.2',
  style: style.stageTwoTwo
}];
export const GenplanSignatures = () => {
  const $ = _c(10);
  const {
    isMobile
  } = useViewport();
  let t0;
  if ($[0] !== isMobile) {
    t0 = !isMobile && <span className={cn(style.signature, style.road)}>Волоколамское шоссе</span>;
    $[0] = isMobile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isMobile) {
    t1 = !isMobile && signaturesArr.map(_temp);
    $[2] = isMobile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isMobile) {
    t2 = isMobile && signaturesArrMob.map(_temp2);
    $[4] = isMobile;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <div className={style.wrapper}>{t0}{t1}{t2}</div>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(item) {
  return <BlurTooltip key={item.id} someStyles={cn(style.blurSignature, item.style)} children={<span>{item.text}</span>} />;
}
function _temp2(item_0) {
  return <BlurTooltip key={item_0.id} someStyles={cn(style.blurSignature, item_0.style)} children={<span>{item_0.text}</span>} />;
}